import { render, staticRenderFns } from "./NewLocationPickupInput.vue?vue&type=template&id=ded64326&lang=pug"
import script from "./NewLocationPickupInput.vue?vue&type=script&lang=ts"
export * from "./NewLocationPickupInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlacesSearchRefined: require('/app/components/vantone/PlacesSearchRefined.vue').default,TextInputError: require('/app/components/generic/forms/TextInputError.vue').default})
